export default __webpack_public_path__ + "static/media/carrental.d3f6ea18.png";